var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrillLeft1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "-1.0000000000000022 -0.13653443691637213 76.47523532694379 116.19424234587498",
    width: 72.48,
    height: 112.19,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.89 34.76C26.71 35.1 26.68 27.09 31.83 26.74C41.47 26.11 51.13 26.75 60.58 28.65C65.63 29.68 63.6 37.45 58.54 36.44C49.78 34.71 40.82 34.14 31.89 34.76Z",
    id: "g1Nno3bLNT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.72 94.22C74.82 91.8 70.99 84.75 66.89 87.2C63.77 89.03 38.84 103.71 35.73 105.54C31.66 107.93 35.47 114.97 39.56 112.56C45.79 108.89 67.6 96.05 70.72 94.22Z",
    id: "a4O9Vr2AG0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.64 71.13C27.98 73.37 24.08 66.39 28.75 64.14C31.11 63.01 50.01 53.94 52.38 52.8C57.02 50.52 60.9 57.51 56.25 59.76C51.53 62.03 35 70 32.64 71.13Z",
    id: "d1oshOZ1Us"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.55 87.82C36.19 85.54 41.3 82.44 46.77 79.99C48.35 79.27 49.79 78.24 51.55 77.6C52.96 77.13 54.46 76.97 55.04 77.69C55.63 78.41 54.68 79.42 53.78 80.2C51.25 82.25 48.57 84.1 45.75 85.73C40.42 89.01 34.76 91.89 29.07 94.73C28.5 94.97 27.96 95.27 27.44 95.6C26.38 96.38 25.23 97.06 24.12 96.57C23 96.08 22.57 95.38 23.4 94.21C24.62 95.11 25.83 95.36 27.77 93.83C29.15 92.77 31.37 92.71 32.64 91.35C32.12 91.45 31.42 91.72 30.85 91.45C30.52 91.29 30.14 91.24 29.77 91.31C29.4 91.38 29.06 91.56 28.8 91.83C28.41 92.15 27.48 92.53 27.47 92.23C27.5 90.55 25.62 92.12 24.82 91.78C26.35 89.98 28.33 88.61 30.55 87.82Z",
    id: "awTSQWzDY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.53 90.17C27.59 90.84 27.65 91.44 27.72 92.26C28.95 91.16 29.84 89.61 31.39 91.1C32.17 91.81 32.84 90.32 34.1 89.92C33.31 91.36 32.88 92.58 30.65 93.11C29.51 93.38 28.42 93.83 27.42 94.44C24.46 96.38 24.43 96.41 23.38 94.2C23.17 93.3 23.59 92.48 24.82 91.78C25.87 91.53 26.51 90.81 27.53 90.17Z",
    id: "c1aqGDKX6O"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.51 43.34C50.1 44.1 48.52 45.1 47.03 45.86C42.9 47.86 38.66 49.63 34.33 51.16C26 54.29 17.33 56.97 8.64 59.62C7.77 59.86 6.92 60.15 6.08 60.48C4.42 61.22 2.6 61.88 1.2 61.32C-0.05 60.83 -0.59 60.02 0.9 58.87C0.81 57.93 1.65 57.12 3.54 56.44C5.87 54.65 9.46 53.43 12.62 52.65C21.09 50.55 29.05 47.62 37.38 45.32C39.8 44.66 42.1 43.57 44.71 43.09C46.8 42.67 48.92 42.58 49.51 43.34Z",
    id: "a546lOBep"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.55 13.94C47.72 11.76 41.98 9.06 36.3 6.33C35.76 6.03 35.19 5.79 34.6 5.6C33.34 5.24 32.1 4.76 31.82 3.56C31.56 2.51 31.83 1.61 33.25 1.55C33.81 0.79 34.72 0.66 36.02 1.16C38.38 1.25 40.66 1.97 42.63 3.25C47.87 6.29 53.41 8.4 58.72 11.2C60.24 12.01 61.97 12.48 63.51 13.5C64.74 14.33 65.78 15.41 65.55 16.32C65.33 17.23 63.97 17.1 62.8 16.86C59.64 16.13 56.55 15.16 53.55 13.94Z",
    id: "l1Sy3cO5vm"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g1Nno3bLNT",
    opacity: 1,
    fill: "#00afef",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g1Nno3bLNT",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4O9Vr2AG0",
    opacity: 1,
    fill: "#ffa13e",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4O9Vr2AG0",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1oshOZ1Us",
    opacity: 1,
    fill: "#59fac3",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1oshOZ1Us",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#awTSQWzDY",
    opacity: 1,
    fill: "#08576d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#awTSQWzDY",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1aqGDKX6O",
    opacity: 1,
    fill: "#08576d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1aqGDKX6O",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a546lOBep",
    opacity: 1,
    fill: "#08576d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a546lOBep",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l1Sy3cO5vm",
    opacity: 1,
    fill: "#08576d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l1Sy3cO5vm",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrillLeft1);
export default __webpack_public_path__ + "static/media/frill_left-1.52bd0f8c358269b62d2b536044250c6f.svg";
export { ForwardRef as ReactComponent };